import React, { Component } from 'react';
import Login from './components/Login';
// import Reboot from 'material-ui/Reboot/Reboot';
// import { withStyles } from 'material-ui/styles';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';

import './App.css'

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#6DADCE',
      main: '#015E89',
      dark: '#003559',
      contrastText: '#fff',
    },
  },
});

class App extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div>
          <div className="background-img">
            <div class="back-home-btn">
              <a
                href="https://nestor-arguello.github.io"
                target="_self"
                title="Back Home"
              >
                &#8617;
              </a>
            </div>
          </div>
          <div className="App">
            <Login />
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js